module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "about-us"
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('h2', {
    staticClass: "page_title"
  }, [_vm._v("ABOUT US")]), _vm._v(" "), _c('div', {
    staticClass: "buttons-row"
  }, [_c('a', {
    staticClass: "tab-link button",
    class: {
      active: _vm.isMedia
    },
    style: ([_vm.isMedia ? _vm.borderStyle : {
      'background-color': '#fff',
      'color': '#000'
    }]),
    attrs: {
      "href": '#' + _vm.tabMedia
    },
    on: {
      "click": _vm.setMedia
    }
  }, [_vm._v("Media")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    class: {
      active: _vm.isBio
    },
    style: ([_vm.isBio ? _vm.borderStyle : {
      'background-color': '#fff',
      'color': '#000'
    }]),
    attrs: {
      "href": '#' + _vm.tabBio
    },
    on: {
      "click": _vm.setBio
    }
  }, [_vm._v("Bio")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    class: {
      active: _vm.isSocial
    },
    style: ([_vm.isSocial ? _vm.borderStyle : {
      'background-color': '#fff',
      'color': '#000'
    }]),
    attrs: {
      "href": '#' + _vm.tabSocial
    },
    on: {
      "click": _vm.setSocial
    }
  }, [_vm._v("Social")])]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "tabs-animated-wrap",
    attrs: {
      "id": "focusDiv"
    }
  }, [_c('div', {
    staticClass: "tabs",
    style: ({
      transform: 'translate3d(' + _vm.activeTabUsage + '%, 0px, 0px)'
    })
  }, [_c('div', {
    staticClass: "page-content tab",
    class: {
      active: _vm.isMedia
    },
    staticStyle: {
      "overflow-y": "hidden"
    },
    attrs: {
      "id": _vm.tabMedia
    }
  }, [_c('div', [(_vm.model.dealerYoutube) ? _c('div', {
    staticClass: "page_single layout_fullwidth_padding"
  }, [_c('div', {
    staticClass: "videocontainer"
  }, [_c('div', {
    staticClass: "fluid-width-video-wrapper"
  }, [_c('iframe', {
    staticClass: "video",
    attrs: {
      "src": _vm.model.dealerYoutube,
      "frameborder": "0"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "page_title"
  }, [_vm._v("PHOTOS")]), _vm._v(" "), (_vm.model.dealerPhotos) ? _c('div', [_c('ul', {
    class: {
      'photo_gallery_13': _vm.imageViewId == 0,
      'photo_gallery_12': _vm.imageViewId == 1,
      'photo_gallery_11': _vm.imageViewId == 2
    },
    attrs: {
      "id": "photoslist"
    }
  }, [_vm._l((_vm.model.dealerPhotos), function(image, key) {
    return _c('li', {
      key: key,
      attrs: {
        "image": image
      }
    }, [_c('a', {
      staticClass: "swipebox",
      attrs: {
        "rel": "gallery-3",
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openPhotoBrowser(key)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": image,
        "alt": "image"
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearleft"
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isMedia) ? _c('div', {
    staticClass: "bottombarpages",
    style: ({
      'background-color': _vm.customization.mainColor
    })
  }, [_c('div', {
    staticClass: "gallery_switch"
  }, [_c('a', {
    staticClass: "switcher active",
    attrs: {
      "href": "#",
      "id": "view13"
    },
    on: {
      "click": function($event) {
        return _vm.changeImageView(0)
      }
    }
  }, [_c('span', {
    staticClass: "icon-customer-app icon-switch13",
    style: ([_vm.imageViewId == 0 ? {
      'color': _vm.customization.iconColor
    } : {
      'color': _vm.customization.fontColor
    }])
  })]), _vm._v(" "), _c('a', {
    staticClass: "switcher",
    attrs: {
      "href": "#",
      "id": "view12"
    },
    on: {
      "click": function($event) {
        return _vm.changeImageView(1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-customer-app icon-switch12",
    style: ([_vm.imageViewId == 1 ? {
      'color': _vm.customization.iconColor
    } : {
      'color': _vm.customization.fontColor
    }])
  })]), _vm._v(" "), _c('a', {
    staticClass: "switcher",
    attrs: {
      "href": "#",
      "id": "view11"
    },
    on: {
      "click": function($event) {
        return _vm.changeImageView(2)
      }
    }
  }, [_c('span', {
    staticClass: "icon-customer-app icon-switch11",
    style: ([_vm.imageViewId == 2 ? {
      'color': _vm.customization.iconColor
    } : {
      'color': _vm.customization.fontColor
    }])
  })])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab page-content",
    class: {
      active: _vm.isBio
    },
    attrs: {
      "id": _vm.tabBio
    }
  }, [_c('div', {
    staticClass: "page_single layout_fullwidth_padding m-t-40"
  }, [_c('blockquote', {
    style: (_vm.borderStyle),
    attrs: {
      "id": "info"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tab page-content",
    class: {
      active: _vm.isSocial
    },
    attrs: {
      "id": _vm.tabSocial
    }
  }, [(_vm.model.socialLinks.length > 0) ? _c('ul', {
    staticClass: "social_share"
  }, [(_vm.model.socialLinks[_vm.socialEnum.twitter].value) ? _c('li', [_c('a', {
    staticClass: "external",
    attrs: {
      "href": _vm.model.socialLinks[_vm.socialEnum.twitter].value,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.LogActivity('TWITTER')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/icons/black/twitter.png"),
      "alt": "",
      "title": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("TWITTER")])])]) : _vm._e(), _vm._v(" "), (_vm.model.socialLinks[_vm.socialEnum.facebook].value) ? _c('li', [_c('a', {
    staticClass: "external",
    on: {
      "click": function($event) {
        return _vm.redirectToFacebookApp()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/icons/black/facebook.png"),
      "alt": "",
      "title": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("FACEBOOK")])])]) : _vm._e(), _vm._v(" "), (_vm.model.socialLinks[_vm.socialEnum.pinterest].value) ? _c('li', [_c('a', {
    staticClass: "external",
    attrs: {
      "href": _vm.model.socialLinks[_vm.socialEnum.pinterest].value,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.LogActivity('PINTEREST')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/icons/black/pinterest.png"),
      "alt": "",
      "title": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("PINTEREST")])])]) : _vm._e(), _vm._v(" "), (_vm.model.socialLinks[_vm.socialEnum.linkedin].value) ? _c('li', [_c('a', {
    staticClass: "external",
    attrs: {
      "href": _vm.model.socialLinks[_vm.socialEnum.linkedin].value,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.LogActivity('LINKEDIN')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/icons/black/linkedin.png"),
      "alt": "",
      "title": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("LINKEDIN")])])]) : _vm._e()]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('f7-photo-browser', {
    ref: "pb",
    attrs: {
      "init": false
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1e6f070f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e6f070f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/about/about-us.vue
// module id = 747
// module chunks = 0